/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import { CellProps } from "./MovementCell";
import FlightIcon from "@mui/icons-material/Flight";
import { Typography, useTheme } from "@mui/material";

interface WaitlistCellProps extends CellProps {
  flightName: string;
  departureLocation: string;
  arrivalLocation: string;
}

const WaitlistCell = (props: WaitlistCellProps) => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: "flex",
        padding: 5,
        background: theme.palette.cells.waitlist.background,
        borderRadius: 5,
        alignItems: "start",
        flexDirection: "column",
        width: "100%",
        minHeight: 50,
      }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <FlightIcon fontSize="small" color="inherit" />
        <Typography variant="caption" maxWidth={50} noWrap={true}>
          {props.flightName}
        </Typography>
      </div>
      <div>
        <Typography variant="caption" maxWidth={50} noWrap={true}>
          {props.departureLocation} &rarr; {props.arrivalLocation}
        </Typography>
      </div>
    </div>
  );
};

export default WaitlistCell;
